export default __webpack_public_path__ + "static/media/BM_RenderCamera_02_LivingA+Interior+Light_Scheme+Living.735828e6.jpg";